module.exports = __webpack_public_path__ + "img/vertical_4_3_8023.e9c573a7.png";